<div
  data-at-sidenav-content
  class="sidenav flex flex-col justify-between items-stretch w-full min-w-full h-full min-h-full"
>
  <div>
    <div class="sidenav-close light-grey flex flex-row justify-end items-center">
      <button mat-icon-button class="close-button" (click)="onClick()">
        <mat-icon iconPositionEnd>close</mat-icon>
      </button>
    </div>
    <div data-at-home class="sidenav-content light-grey flex flex-row flex-wrap">
      <ng-content select="[home]"></ng-content>
    </div>
    <div data-at-top class="top sidenav-content flex flex-row flex-wrap">
      <ng-content select="[top]"></ng-content>
    </div>
    <div data-at-middle class="middle sidenav-content flex flex-row flex-wrap">
      <ng-content select="[middle]"></ng-content>
    </div>
    <div data-at-bottom class="bottom sidenav-content flex flex-row flex-wrap">
      <ng-content select="[bottom]"></ng-content>
    </div>
    <div data-at-bottom class="bottom sidenav-content flex flex-row flex-wrap">
      <ng-content select="[version]"></ng-content>
    </div>
  </div>
  ​
  <div data-at-footer class="footer flex flex-row flex-wrap">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
